/**
 * Kamus **layar pelayan**.
 *
 * ⚠️ Tak ada kata soal uang di sini — bukan kebetulan. Pelayan tak memegang uang, dan kosakata yang
 * menyebut "bayar"/"total" di layarnya hanya melatih orang mencari tombol yang memang tak ada.
 */
export const waiterId = {
  title: 'Pelayan',
  back: 'Kembali ke meja',
  send: 'Kirim ke dapur',
  degraded: 'Sambungan tersendat — daftar meja bisa telat',
  /* ⛔ Disebut di depan, bukan jadi galat saat menekan kirim. */
  dayClosed: 'Hari usaha ini sudah ditutup — pesanan baru tak bisa dibuka',
  noBusinessDate: 'Tanggal usaha gagal dibaca dari server — jangan buka pesanan dulu',
};

export const waiterEn: typeof waiterId = {
  title: 'Waiter',
  back: 'Back to tables',
  send: 'Send to kitchen',
  degraded: 'Connection lagging — the table list may be behind',
  dayClosed: 'This business day is closed — no new orders',
  noBusinessDate: 'Could not read the business date from the server — do not open orders yet',
};
